const READ_ONLY_REJECTION_SUPPRESSION_WINDOW_MS = 500;

let lastReadOnlyRejectionAt = 0;

export const markViewAsBuyerReadOnlyRejection = (): void => {
    lastReadOnlyRejectionAt = Date.now();
};

export const isWithinViewAsBuyerReadOnlyRejectionWindow = (): boolean => {
    return (
        Date.now() - lastReadOnlyRejectionAt <
        READ_ONLY_REJECTION_SUPPRESSION_WINDOW_MS
    );
};
